import { StatementCategoryOperationEnum } from "./StatementCategoryOperationEnum";

export class StatementInfoModel
{
	public Id: string = '';
	public CategoryId: string = '';
	public Phone: string = '';
	public Email: string = '';
	public Href: string = '';
	public Operation: StatementCategoryOperationEnum = StatementCategoryOperationEnum.None;
}
